import { Action, ActionContext } from 'actions';
import { inviteUser } from './inviteUser';

export const userActions = (context: ActionContext) =>
  ({
    inviteUser: inviteUser(context),
  } satisfies Record<string, Action>);
